import Recipients from "pages/PanelPage/components/selectedAssessment/assessmentInvite/Recipients/Recipients";

export default Recipients;
